import React, { useState } from 'react';
import { MentorShort } from '../../../../api/types/mentorShort';
import { Components } from './styled';

const formatDuration = (seconds: number) => {
  const total = Number(seconds) || 0;
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
};

// Drag-and-drop list (native HTML5 drag events, no extra dependency) for one
// mentor's shorts. Reports the new order; the parent decides when to save it.
const ReorderableShortsList = ({
  items,
  onReorder,
  onEdit,
}: {
  items: MentorShort[];
  onReorder: (orderedIds: string[]) => void;
  onEdit: (id: string) => void;
}) => {
  const [draggedId, setDraggedId] = useState<string | undefined>(undefined);
  const [overId, setOverId] = useState<string | undefined>(undefined);

  const move = (fromId: string, toId: string) => {
    const from = items.findIndex((item) => item.id === fromId);
    const to = items.findIndex((item) => item.id === toId);
    if (from < 0 || to < 0 || from === to) {
      return;
    }
    const ids = items.map((item) => item.id);
    ids.splice(to, 0, ids.splice(from, 1)[0]);
    onReorder(ids);
  };

  const resetDrag = () => {
    setDraggedId(undefined);
    setOverId(undefined);
  };

  return (
    <Components.List>
      {items.map((item) => (
        <Components.Row
          key={item.id}
          draggable
          isDragging={draggedId === item.id}
          isDropTarget={!!draggedId && overId === item.id && draggedId !== item.id}
          onDragStart={(e) => {
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/plain', item.id);
            setDraggedId(item.id);
          }}
          onDragOver={(e) => {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
            setOverId(item.id);
          }}
          onDrop={(e) => {
            e.preventDefault();
            if (draggedId) {
              move(draggedId, item.id);
            }
            resetDrag();
          }}
          onDragEnd={resetDrag}>
          <Components.Handle aria-hidden={'true'} title={'Drag to reorder'}>
            ⋮⋮
          </Components.Handle>
          <Components.Title>{item.title}</Components.Title>
          <Components.Meta>{formatDuration(item.durationSeconds)}</Components.Meta>
          <Components.Meta>{item.isActive ? 'Active' : 'Inactive'}</Components.Meta>
          <Components.Actions>
            <Components.ActionButton type={'button'} onClick={() => onEdit(item.id)}>
              Edit
            </Components.ActionButton>
          </Components.Actions>
        </Components.Row>
      ))}
    </Components.List>
  );
};

export default ReorderableShortsList;
